import { Group, Loader } from "@mantine/core";
import { memo } from "react";
import { areEqual } from "react-window";
import LeadItemMobile from "../../prospect/mobile/LeadItemMobile";

const RowMobile = memo(({ data, index, style }) => {
  const { container } = data;
  const current = container.items[index];

  return (
    <div style={{ ...style, marginTop: 8 }}>
      {current?.id ? (
        <LeadItemMobile current={current} container={container} index={index} />
      ) : (
        <Group w={"100%"} justify="center" h={"100%"}>
          <Loader type="dots" />
        </Group>
      )}
    </div>
  );
}, areEqual);

RowMobile.displayName = "Row";

export default RowMobile;
